import React, { useContext, useEffect, useState } from "react";
import "./ScanMartStore.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faArrowRight,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { Rating } from "react-simple-star-rating";
import TrandBee from "./TrandBee";
import Veggies_Section_Card from "../../Common-Component/Veggies_Section_Card/Veggies_Section_Card";
import Online_Store from "../../Common-Component/Online_Store/Online_Store";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Veiw_All_Card from "../../Common-Component/Veiw_All_Card/Veiw_All_Card";
import { Category } from "../../../utils/apis/Product/Product";
import { NearSellerGet } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";
import { sellerCategory } from "../../../utils/apis/SellerApi/SellerApi";
import { Link, useNavigate } from "react-router-dom";
import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import { AppSetup } from "../../../utils/apis/common/Common";

const ScanMartStore = () => {
  const [rating, setRating] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [likedProducts, setLikedProducts] = useState([]); // State to track liked products
  const [addCartModal, setAddCartModal] = useState(false);

  const [city, setCity] = useState(null);


  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };


  const handleRating = (rate: number) => {
    setRating(rate);
  };

  const handleReset = () => {
    // Set the initial value
    setRating(0);
  };

  const handleLike = (index) => {
    setLikedProducts((prevLikedProducts) => {
      const updatedLikedProducts = [...prevLikedProducts];
      updatedLikedProducts[index] = !updatedLikedProducts[index];
      return updatedLikedProducts;
    });
  };

  const { IMG_URL, getData, triggerCartUpdate } = useContext(Context);
  const [activeCategory, setActiveCategory] = useState("first");
  const [category, setCategory] = useState([]);
  const getCategory = async () => {
    const res = await Category();
    if (res?.success) {
      setCategory(res?.data);
    }
  };

  const [seller, setSeller] = useState([]);

  const getSeller = async (value) => {
    setSeller([]); // 🔥 clear before API call

    const categoryId = value?.id || "";
    const cityParam = city || "";

    const res = await NearSellerGet(cityParam, categoryId);

    if (res.success) {
      setSeller(res.data);
    }

    // if (res?.success && Array.isArray(res?.data)) {
    //   setSeller(res.data);
    // } else {
    //   setSeller([]);
    // }

    setActiveCategory(value?.name || "first");
  };

  const [sellerByCategory, setSellerByCategory] = useState([]);
  const getSellerByCat = async (id) => {
    const res = await getData(
      `/without-login/home/seller-product-category?category_id=${id?.id}`,
    );
    if (res?.success) {
      setSellerByCategory(res?.data);
    }
  };

  const navigate = useNavigate();
  const handleNext = async (id) => {
    const res = await sellerCategory(id);
    if (res?.success) {
      localStorage.setItem("seller_id", id);
      navigate(`/select-from-category/${id}`);
    }
  };

  useEffect(() => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`,
        );
        const data = await res.json();

        setCity(
          data.address.city ||
            data.address.county ||
            data.address.village ||
            "",
        );
      },
      (err) => console.error(err),
    );

    getCategory();
    getSetup();
    getSeller();
  }, []);

  useEffect(() => {
    triggerCartUpdate();
  }, [addCartModal]);

  useEffect(() => {
    getSellerByCat();
    getSetup();
  }, []);

  useEffect(() => {
    if (city !== null) {
      getSeller();
    }
  }, [city]);

  return (
    <>
      <section className="near-mart-store">
        <div className="container">
          <div className="heading-holder">
            <h1>Near by shops</h1>
          </div>

          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row>
              <Col sm={12}>
                <Nav variant="pills" className="flex-row fliter-product-slide">
                  <Swiper
                    className="mySwiper1"
                    breakpoints={{
                      0: {
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                      },
                      420: {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                      },
                      486: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                      },
                      992: {
                        slidesPerView: 8,
                        spaceBetween: 10,
                      },
                      1200: {
                        slidesPerView: 8,
                        spaceBetween: 10,
                      },
                    }}
                  >
                    <SwiperSlide className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          className={activeCategory === "first" ? "active" : ""}
                          onClick={() => getSeller()}
                        >
                          All
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>

                    {category?.map((value, index) => (
                      <SwiperSlide className="product-slide">
                        <Nav.Item>
                          <Nav.Link
                            className={
                              activeCategory == value?.name ? "active" : ""
                            }
                            onClick={() => getSeller(value)}
                          >
                            {value?.name}
                          </Nav.Link>
                        </Nav.Item>
                      </SwiperSlide>
                    ))}

                    {/* <SwiperSlide className="product-slide">
                      <Nav.Item>
                        <Nav.Link eventKey="Third">Electronic</Nav.Link>
                      </Nav.Item>
                    </SwiperSlide> */}
                  </Swiper>
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    {seller?.length === 0 ? (
                      <div>No product available</div>
                    ) : (
                      seller?.map((value, index) => (
                        <div className="slider-sec" key={index}>
                          <div className="view_all_div">
                            <p
                              className="view_all_text"
                              onClick={() =>
                                handleNext(
                                  value?.user?.products[0]?.category_id,
                                )
                              }
                            >
                              View All{" "}
                              <FontAwesomeIcon
                                icon={faArrowRight}
                                className="inner_icon"
                              />
                            </p>
                          </div>

                          <div className="row">
                            <div className="col-lg-3 col-md-4 mt-3">
                              <Online_Store
                                rating={value?.user?.store_rating}
                                handleRating={handleRating}
                                image={
                                  value?.logo
                                    ? IMG_URL + value.logo
                                    : IMG_URL + setups?.image
                                }
                                heading={value?.store_name}
                                city={value?.city?.name}
                                distanceLocation="5 minutes away from your location"
                              />
                            </div>
                            <div className="col-lg-9 col-md-8 mt-3">
                              <Swiper
                                breakpoints={{
                                  0: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                  },
                                  420: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                  },
                                  486: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                  },
                                  768: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 10,
                                  },
                                  992: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 10,
                                  },
                                  1200: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                  },
                                  1400: {
                                    slidesPerView: 4.5,
                                    spaceBetween: 10,
                                  },
                                  1900: {
                                    slidesPerView: 4.5,
                                    spaceBetween: 10,
                                  },
                                }}
                                navigation={true}
                                modules={[Navigation, Pagination]}
                                pagination={{
                                  dynamicBullets: true,
                                  clickable: true,
                                }}
                                className="mySwiper scanmart_swiper"
                                onSwiper={(swiper) => setSwiperInstance(swiper)}
                              >
                                {value?.user?.products.length === 0 ? (
                                  <SwiperSlide>
                                    No product Available
                                  </SwiperSlide>
                                ) : (
                                  value?.user?.products.map((item, index) => (
                                    <SwiperSlide
                                      key={`${index}-${item.detailsLink}`}
                                    >
                                      <Veggies_Section_Card
                                        image={IMG_URL + item?.image1}
                                        vegetableName={item?.name}
                                        price={
                                          item?.product_variants[0]?.s_price
                                            ? item?.product_variants[0]?.s_price
                                            : item?.product_multiple_variants[0]
                                                ?.s_price
                                        }
                                        offprice={
                                          item?.product_variants[0]?.mrp
                                            ? item?.product_variants[0]?.mrp
                                            : item?.product_multiple_variants[0]
                                                ?.mrp
                                        }
                                        product={item}
                                        setAddCartModal={setAddCartModal}
                                        variant={item?.product_variants[0]}
                                        m_variant={
                                          item?.product_multiple_variants[0]
                                        }
                                      />
                                    </SwiperSlide>
                                  ))
                                )}
                                {/* <SwiperSlide>
                                  <div
                                    onClick={() =>
                                      handleNext(
                                        value?.user?.products[0]?.category_id,
                                      )
                                    }
                                    className="view_all_main_card_holder"
                                  >
                                    <Veiw_All_Card />
                                  </div>
                                </SwiperSlide> */}
                              </Swiper>

                              <div className="silder-btn">
                                <div
                                  className="back-btn"
                                  onClick={() => handleMainSliderClick("prev")}
                                ></div>
                                <div
                                  className="next-btn"
                                  onClick={() => handleMainSliderClick("next")}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="second">Second tab content</Tab.Pane>
                  <Tab.Pane eventKey="Third">Third tab content</Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
          <SupermarketModal
            show={addCartModal}
            onHide={() => setAddCartModal(false)}
          />
        </div>
      </section>
    </>
  );
};

export default ScanMartStore;
